<template>
    <Modal
        buttonText="Creditnota"
        :buttonDisabled="buttonDisabled"
        ref="modalCreditNote"
    >
        <Form @submitted="postCreditNote">
            <h3>Creditnota</h3>
            <Input
                type="text"
                label="Nummer"
                name="reference"
                :required="false"
                v-model="formCreditNote.reference"
                :error="formCreditNote.errors.reference"
                layout="vertical"
            />
            <Input
                type="text"
                label="Bankrekeningnr."
                name="bank_account"
                :required="true"
                v-model="formCreditNote.bank_account"
                :error="formCreditNote.errors.bank_account"
                layout="vertical"
            />
            <Input
                type="double"
                label="Terug te betalen bedrag"
                name="refund"
                v-model="formCreditNote.refund"
                :error="formCreditNote.errors.refund"
                layout="vertical"
            />
            <Input
                label="Excel creditnota"
                name="credit_note_attachment"
                type="file"
                accept=".xls,.xlsx"
                :multiple="false"
                :fileDragDrop="true"
                heightDragDrop="130"
                v-model="formCreditNote.credit_note_attachment"
                :error="formCreditNote.errors.credit_note_attachment"
            />
            <div class="flex justify-between items-center">
                <a
                    href="/various/download-template-credit-note"
                    class="mr-4"
                    v-if="this.$page.props.user.permissions.includes('templates.creditnote')"
                >
                    Sjabloon creditnota downloaden
                </a>

                <div class="inline-block self-end mt-4">
<!--                    <Button text="Annuleren" buttonClass="secondary" data-modal="close" @click="formCreditNote.reset()" />-->
                    <Button
                        text="Opslaan"
                        buttonType="submit"
                        buttonClass="save"
                        :loading="formCreditNote.processing"
                    />
                </div>
            </div>
        </Form>
    </Modal>
</template>

<script>
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'

import {Inertia} from "@inertiajs/inertia";
import {ref, watch} from "vue";
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Button,
        Modal,
        Form,
        Input,
    },
    props: {
        request: {
            required: true
        },
        createCreditNote: {
            required: false,
            default: false,
        },
        cancelRequest: {
            required: false,
            default: false,
        },
        buttonDisabled: {
            required: false,
            default: false,
        },
    },
    setup(props) {
        let modalCreditNote = ref(null)

        const formCreditNote = useForm({
            credit_note: true,
            reference: null,
            bank_account: null,
            refund: null,
            credit_note_attachment: null,
            cancelRequest: props.cancelRequest,
        })

        function postCreditNote()
        {
            formCreditNote.post(route('requests.store-credit-note', { 'request': props.request.id }),
                {
                    onSuccess: () => {
                        modalCreditNote.value.show = false
                        formCreditNote.reset()
                    }
                })
        }

        watch(() => props.createCreditNote, (createCreditNoteVal) => {

            //Check if createCreditNote event is triggered in the parent (Via cancel button)
            if (createCreditNoteVal)
            {
                modalCreditNote.value.show = createCreditNoteVal
                formCreditNote.cancelRequest = props.cancelRequest
            }
        })

        return {
            modalCreditNote,
            formCreditNote,
            postCreditNote,
        }
    }
}
</script>
